import { useId } from 'react';

import Icon from 'ms-ui-primitives/Icon';

import type { Props } from '../types';

const Lock = ({ color, size, title, titleId, aphroditeStyles = [] }: Props) => {
  const mask1Id = useId();
  const mask2Id = useId();

  return (
    <Icon
      color={color}
      size={size}
      aphroditeStyles={aphroditeStyles}
      title={title}
      titleId={titleId}
      viewBoxHeight={20}
      viewBoxWidth={20}
    >
      <mask
        id={mask2Id}
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="3"
        y="0"
        width="14"
        height="19"
      >
        <mask
          id={mask1Id}
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <path fill="#D9D9D9" d="M0 0h20v20H0z" />
        </mask>
        <g mask={`url(#${mask1Id})`}>
          <path
            d="M5 18.333c-.458 0-.85-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.177V8.333c0-.458.164-.85.49-1.177.326-.326.719-.49 1.177-.49h.833V5c0-1.153.407-2.136 1.22-2.948C7.864 1.239 8.846.833 10 .833s2.136.406 2.948 1.219c.813.812 1.219 1.795 1.219 2.948v1.666H15c.459 0 .85.164 1.177.49.327.326.49.719.49 1.177v8.333c0 .459-.163.851-.49 1.177-.326.327-.718.49-1.177.49H5Zm5-4.167c.459 0 .85-.163 1.177-.49.327-.326.49-.718.49-1.176 0-.459-.163-.851-.49-1.177a1.605 1.605 0 0 0-1.177-.49c-.458 0-.85.163-1.177.49-.326.326-.49.718-.49 1.177 0 .458.164.85.49 1.177.326.326.719.49 1.177.49Zm-2.5-7.5h5V5c0-.695-.243-1.285-.729-1.771a2.41 2.41 0 0 0-1.77-.73 2.41 2.41 0 0 0-1.772.73 2.41 2.41 0 0 0-.729 1.77v1.667Z"
            fill="#1C1B1F"
          />
        </g>
      </mask>
      <g mask={`url(#${mask2Id})`}>
        <path d="M0 0h20v20H0z" />
      </g>
    </Icon>
  );
};

Lock.displayName = 'Lock';

export default Lock;
